"use client";

// icons
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import IconWrapper from "@/components/ui/IconWrapper";

// images
import Image from "next/image";

// utils
import clsx from "clsx";
import { pushCtaClickDataLayer } from "@/utils/pushCtaClickDataLayer";

// navigation
import { Link } from "@/i18n/navigation";

/* 
example data: 

 {
    "Id": 0,
    "Title": "Gelişmiş Arama Teknolojisi Otobüs Bileti",
    "Description": "Gelişmiş Arama Teknolojisi",
    "Icon": "fa-radar"
  }

  // IconUrl varsa Icon yerine IconUrl kullanılır
  {
    "Id": 0,
    "Title": "Turna Puan",
    "Description": "Seyahat ettikçe Turna puan kazan, puanlarını seyahatlerinde harca.",
    "Icon": "fa-radar",
    "IconUrl": "https://cdn.turna.com/saka/bus/bus-ticket-state/turna-puan.png"
  }

*/

export default function BenefitCard({
  item,
  translationNamespace = "common",
  descriptionClassName = "",
  dataLayerPayload = null,
}) {
  const resolveFaIcon = (iconStr) => {
    if (!iconStr || typeof iconStr !== "string") return undefined;
    const cleaned = iconStr.trim().replace(/\s+/g, "");
    const name = cleaned.startsWith("fa-") ? cleaned.slice(3) : cleaned;
    // Try families in order: regular, solid, brands
    return (
      byPrefixAndName?.far?.[name] ||
      byPrefixAndName?.fas?.[name] ||
      byPrefixAndName?.fab?.[name]
    );
  };

  const { Id, Title, Description, Icon, IconUrl, Href, SubDescription, ImageUrl } = item || {};
  const iconDef = resolveFaIcon(Icon);

  const handleClick = () => {
    if (dataLayerPayload) {
      pushCtaClickDataLayer(dataLayerPayload, Title);
    }
  };

  return (
    <div className="items-left shadow-small flex w-full flex-col justify-start gap-3 rounded-lg bg-white p-6 h-full">
      <div className="relative flex h-[72px] w-[72px] items-center justify-center">
        {IconUrl || ImageUrl ? (
          <Image
            src={IconUrl || ImageUrl}
            alt={Title || "Icon"}
            fill
            className="object-contain w-full h-full"
            loading="lazy"
          />
        ) : (
          iconDef && (
            <IconWrapper
              icon={iconDef}
              className="text-primary"
              sizePx={72}
              widthPx={72}
              heightPx={72}
              ariaLabel={Title}
            />
          )
        )}
      </div>
      <div className="flex flex-col items-start justify-center gap-2">
        {Title && (
          <div className="text-lg font-semibold">
            {Title}
          </div>
        )}
        {SubDescription || Description  && (
          <div
            className={clsx(
              "text-primary-muted-subtext line-clamp-3 text-base leading-[21px] font-normal min-h-[63px] h-full",
              descriptionClassName,
            )}
          >
            {SubDescription || Description  }
          </div>
        )}
      </div>

      {Href && <Link href={Href} title={Title} className="absolute inset-0" onClick={handleClick}></Link>}
    </div>
  );
}
